/**
 * 在此封装各种工具类的方法
 */
import Vue, {
	h
} from 'vue'

import Compressor from 'compressorjs';

/*
 * 公共变量
 * */
export let Tool = {

	/*
	 * 处理时间的方法
	 */
	formate: (data, format) => {
		if (!data) {
			return "";
		}
		if (typeof data == "string") {
			data.replace(/-/g, "/");
		}
		data = new Date(data);
		let o = {
			"M+": data.getMonth() + 1, // month
			"d+": data.getDate(), // day
			"h+": data.getHours(), // hour
			"m+": data.getMinutes(), // minute
			"s+": data.getSeconds(), // second
			"q+": Math.floor((data.getMonth() + 3) / 3), // quarter
			S: data.getMilliseconds() // millisecond
		};
		if (/(y+)/.test(format)) {
			format = format.replace(
				RegExp.$1,
				(data.getFullYear() + "").substr(4 - RegExp.$1.length)
			);
		}
		for (let k in o) {
			if (new RegExp("(" + k + ")").test(format)) {
				format = format.replace(
					RegExp.$1,
					RegExp.$1.length == 1 ?
					o[k] :
					("00" + o[k]).substr(("" + o[k]).length)
				);
			}
		}
		return format;
	},
	/**
	 * @param date 日期字符串转对象
	 */
	dateSubstr(date) {
		if (!date) return date;
		return new Date(
			`${date.substr(0, 4)}/${date.substr(4, 2)}/${date.substr(6, 2)}`
		);
	},
	/**
	 *
	 * 判断数值是否存在
	 *
	 * @param value 查找值
	 * @param validList 被查找的数组
	 * @param or boolean
	 *
	 * @return boolean
	 */
	stringArrExists(value, validList) {
		for (let i = 0; i < validList.length; i++) {
			if (value === validList[i]) {
				return true;
			}
		}
		return false;
	},
	findItemIndex(arrayToSearch, filter) {
		for (let i = 0; i < arrayToSearch.length; i++) {
			if (filter(arrayToSearch[i])) {
				return i;
			}
		}
		return -1;
	},
	// 删除左右两端的空格
	trim(str) {
		if (str == null || str == undefined || str == "") {
			return "";
		}
		return str.replace(/(^\s*)|(\s*$)/g, "");
	},
	// 删除左边的空格
	ltrim(str) {
		if (str == null || str == undefined || str == "") {
			return "";
		}
		return str.replace(/(^\s*)/g, "");
	},
	// 删除右边的空格
	rtrim(str) {
		if (str == null || str == undefined || str == "") {
			return "";
		}
		return str.replace(/(\s*$)/g, "");
	},
	// 纯数字
	pureNumber(str) {
		return /^\d*$/.test(str);
	},
	// 纯数字+字母
	pureNumberLetter(str) {
		return /^[A-Za-z0-9]+$/.test(str);
	},
	// 对象是否为空
	isEmptyObject(e) {
		for (let t in e) return !1;
		return !0;
	},
	// 对象是否为空或undefined
	isNoEmty(obj) {
		if (obj && obj != 'null' && obj != 'undefined') {
			return true
		}
		return false
	},
	// 身份证验证
	verifyIdCode: function(idcode) {
		var end = idcode.charAt(idcode.length - 1)
		if (end == "x") {
			idcode = idcode.replace("x", "X");
		}
		// 函数参数必须是字符串，因为二代身份证号码是十八位，而在javascript中，十八位的数值会超出计算范围，造成不精确的结果，导致最后两位和计算的值不一致，从而该函数出现错误。
		// 详情查看javascript的数值范围
		// 加权因子
		var weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
		// 校验码
		var check_code = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];

		var code = idcode + "";
		var last = idcode[17]; //最后一位

		var seventeen = code.substring(0, 17);

		// ISO 7064:1983.MOD 11-2
		// 判断最后一位校验码是否正确
		var arr = seventeen.split("");
		var len = arr.length;
		var num = 0;
		for (var i = 0; i < len; i++) {
			num = num + arr[i] * weight_factor[i];
		}

		// 获取余数
		var resisue = num % 11;
		var last_no = check_code[resisue];

		// 格式的正则
		// 正则思路
		/*
		第一位不可能是0
		第二位到第六位可以是0-9
		第七位到第十位是年份，所以七八位为19或者20
		十一位和十二位是月份，这两位是01-12之间的数值
		十三位和十四位是日期，是从01-31之间的数值
		十五，十六，十七都是数字0-9
		十八位可能是数字0-9，也可能是X
		*/
		var idcard_patter =
			/^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;

		// 判断格式是否正确
		var format = idcard_patter.test(idcode);

		// 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
		return last === last_no && format ? true : false;
	},

	//生成印章
	createSeal(sealName, sealTypeText) {
		let canvas = document.createElement('canvas')
		canvas.width = 250
		canvas.height = 250
		let context = canvas.getContext('2d')
		//context.clearRect(0, 0, 250, 250)
		// 绘制印章边框
		let width = canvas.width / 2
		let height = canvas.height / 2
		context.lineWidth = 7
		context.strokeStyle = '#f00'
		context.beginPath()
		context.arc(width, height, 110, 0, Math.PI * 2)
		context.stroke()

		//画五角星
		this.create5star(context, width, height, 30, '#f00', 0)

		// 绘制印章名称
		context.font = '22px Helvetica'
		context.textBaseline = 'middle' //设置文本的垂直对齐方式
		context.textAlign = 'center' //设置文本的水平对对齐方式
		context.lineWidth = 1
		context.fillStyle = '#f00'
		context.fillText(sealTypeText, width, height + 65)

		// 绘制印章单位
		context.translate(width, height) // 平移到此位置,
		context.font = '22px Helvetica'
		if (this.isNoEmpty(sealName)) {
			var count = sealName.length // 字数
			var angle = (4 * Math.PI) / (3 * (count - 1)) // 字间角度
			var chars = sealName.split('')
			var c
			for (var i = 0; i < count; i++) {
				c = chars[i] // 需要绘制的字符
				if (i == 0) {
					context.rotate((5 * Math.PI) / 6)
				} else {
					context.rotate(angle)
				}
				context.save()
				context.translate(90, 0) // 平移到此位置,此时字和x轴垂直
				context.rotate(Math.PI / 2) // 旋转90度,让字平行于x轴
				context.fillText(c, 0, 5) // 此点为字的中心点
				context.restore()
			}
		}
		return canvas.toDataURL('image/png')
		//console.log(this.imgSrc)
	},
	//绘制五角星
	/**
	 * 创建一个五角星形状. 该五角星的中心坐标为(sx,sy),中心到顶点的距离为radius,rotate=0时一个顶点在对称轴上
	 * rotate:绕对称轴旋转rotate弧度
	 */
	create5star(context, sx, sy, radius, color, rotato) {
		context.save()
		context.fillStyle = color
		context.translate(sx, sy) //移动坐标原点
		context.rotate(Math.PI + rotato) //旋转
		context.beginPath() //创建路径
		var x = Math.sin(0)
		var y = Math.cos(0)
		var dig = (Math.PI / 5) * 4
		for (var i = 0; i < 5; i++) {
			//画五角星的五条边
			var x = Math.sin(i * dig)
			var y = Math.cos(i * dig)
			context.lineTo(x * radius, y * radius)
		}
		context.closePath()
		context.stroke()
		context.fill()
		context.restore()
	},
	//canvas加水印
	createWaterMarker() {
		// 这里限制了不超过15个字，实际按需求来
		let cpyName = '石化e签'
		//let waterCanvas = document.getElementById('waterCanvas')
		let waterCanvas = document.createElement('canvas')
		waterCanvas.width = 250
		waterCanvas.height = 250
		//let waterCanvas = this.canvas;
		// 获取 canvas 元素工具箱
		let waterContext = waterCanvas.getContext('2d')
		//let waterContext = this.context;
		//waterCanvas.height = waterCanvas.height
		//waterContext.beginPath();
		waterContext.translate(-125, -125)
		// 设置文字倾斜角度为 -45 度以及样式
		waterContext.rotate((-45 * Math.PI) / 180)
		waterContext.font = 'bold 14px 楷体'
		waterContext.fillStyle = 'rgba(0,0,0,0.3)'
		waterContext.textAlign = 'center'
		waterContext.textBaseline = 'Middle'
		//waterContext.fillText(cpyName, 0, 5)
		/* 
		  双重遍历，
		  当 宽度小于页面宽度时，
		  当 高度小于页面高度时，
		  这里的宽高可以适当写大，目的是为了让水印文字铺满
		 */
		// console.log(waterCanvas.parentNode)
		// console.log(waterCanvas.parentNode.offsetWidth)
		// console.log(waterCanvas.parentNode.offsetHeight)
		// for (let i = waterCanvas.parentNode.offsetWidth * 0.5 * -1; i < 600; i += 100) {
		// 	for (let j = 0; j < waterCanvas.parentNode.offsetHeight * 3.5; j += 50) {
		// 		// 填充文字，x 间距, y 间距
		// 		waterContext.fillText(cpyName, i, j)
		// 	}
		// }
		for (let i = waterCanvas.width * 0.5 * -1; i < 600; i += 120) {
			for (let j = 0; j < waterCanvas.height * 3.5; j += 60) {
				// 填充文字，x 间距, y 间距
				waterContext.fillText(cpyName, i, j)
			}
		}
		//document.getElementsByClassName("canvasBg")[0].style.backgroundImage = "url(" + waterCanvas.toDataURL("image/png") + ")";
		return waterCanvas.toDataURL('image/png')
	},

	//图片压缩  
	//file文件
	//size压缩的大小 单位字节
	//flag true 印章压缩  false图片压缩
	compressImage(file, size, flag) {
		let width = 1280;
		let height = 760;
		return new Promise((resolve, reject) => {
			this.getImageDimensionsFromFile(file)
				.then(res => {
					console.log('1-=', res)
					if (flag) {
						width = 480;
						height = 480 * res.height / res.width;
					} else {
						width = 1280;
						height = 1280 * res.height / res.width;
					}
					return this.compressImageForWH(file, size.width, height)
					// return new new Promise((resolve, reject) => {
					// 	reject('666')
					// })
				}).then(res => {
					console.log('2-=', res)
					if(res){
						resolve(res)
					}
				}).catch(e => {
					console.log('1-=', e)
					if (flag) {
						width = 480;
						height = 480;
					} else {
						width = 1280;
						height = 760;
					}
					return this.compressImageForWH(file, size.width,height)
					// return new new Promise((resolve, reject) => {
					// 	reject('666')
					// })
				}).then(res => {
					console.log('3-=', res)
					if(res){
						resolve(res)
					}
				}).catch(e => {
					console.log('2-=', e)
					reject(e)
				})
		})
		// if (flag) {
		// 	width = 480;
		// 	height = 480;
		// } else {
		// 	width = 1280;
		// 	height = 760;
		// }
		// return new Promise((resolve, reject) => {
		// 	new Compressor(file.file, {
		// 		quality: 0.6, // 设置压缩质量，范围是 0 到 1，1 为最高质量
		// 		maxWidth: width, // 设置最大宽度
		// 		maxHeight: height, // 设置最大高度
		// 		convertSize: size, // 设置转换后的文件大小限制（字节），例如这里设置为500KB
		// 		success: (result) => {
		// 			// 压缩成功后的回调函数
		// 			console.log('Compressed image:', result);
		// 			const reader = new FileReader();
		// 			reader.readAsDataURL(result); // 将文件转换为Data URL（即Base64编码）
		// 			reader.onloadend = function() {
		// 				console.log('Base64 encoded:', reader.result); // 输出Base64编码的字符串
		// 				resolve(reader.result);
		// 			}
		// 		},
		// 		error: (err) => {
		// 			reject(err)
		// 			// 压缩失败后的回调函数
		// 			console.error('Something went wrong:', err.message);
		// 		},
		// 	});
		// })
		//var that = this
		/*console.log('-compressImage--=', file)
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file.file);
			reader.onload = e => {
				const image = new Image();
				image.src = e.target.result;
				image.onload = () => {
					let quality = 1;
					const canvas = document.createElement('canvas');
					const ctx = canvas.getContext('2d');
					let width = image.width;
					let height = image.height;
					if (width === 0 || height === 0) {
						reject({
							error: '不能读取到图片'
						})
					}
					const scale = width / height;
					if (flag) {
						if (width > 500) {
							width = 500;
							height = width / scale;
						}
					} else {
						if (width > 1000) {
							width = 1000;
							height = width / scale;
						}
					}
					canvas.width = width;
					canvas.height = height;
					ctx.drawImage(image, 0, 0, width, height);
					let dataURL = canvas.toDataURL(file.file.type, quality);
					console.log('-compressImage-=', dataURL.length)
					while (dataURL.length / 1024 > size && quality > 0.01) {
						if (quality < 0.2 && quality > 0.02) {
							quality -= 0.01;
							quality = parseFloat(quality.toFixed(2))
						} else if (quality >= 0.2) {
							quality -= 0.1;
							quality = parseFloat(quality.toFixed(1))
						}
						dataURL = canvas.toDataURL(file.file.type, quality);
						console.log('-compressImage-=', dataURL.length, quality)
					}
					resolve({
						width: width,
						height: height,
						data: dataURL
					});
				};
			};
		})*/
	},

	compressImageForWH(file, size, width, height) {
		return new Promise((resolve, reject) => {
			new Compressor(file.file, {
				quality: 0.6, // 设置压缩质量，范围是 0 到 1，1 为最高质量
				maxWidth: width, // 设置最大宽度
				maxHeight: height, // 设置最大高度
				convertSize: size, // 设置转换后的文件大小限制（字节），例如这里设置为500KB
				success: (result) => {
					// 压缩成功后的回调函数
					console.log('Compressed image:', result);
					const reader = new FileReader();
					reader.readAsDataURL(result); // 将文件转换为Data URL（即Base64编码）
					reader.onloadend = function() {
						console.log('Base64 encoded:', reader
							.result); // 输出Base64编码的字符串
						resolve(reader.result);
					}
				},
				error: (err) => {
					reject(err)
					// 压缩失败后的回调函数
					console.error('Something went wrong:', err.message);
				},
			});
		})
	},

	getImageDimensionsFromFile(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = (e) => {
				const img = new Image();
				img.onload = () => {
					resolve({
						width: img.width,
						height: img.height
					});
				};
				img.onerror = reject;
				img.src = e.target.result;
			};
			reader.onerror = reject;
			reader.readAsDataURL(file.file);
		});
	},

	//判空 包含'null'
	//isTrim 是否判断包含空格的空
	isNoEmpty(str, isTrim = false) {
		//console.log(str)
		if (str && str != 'null') {
			if (isTrim) {
				str = str.trim()
				if (!str || str === 'null') {
					return false
				}
			}
			return true
		}
		return false
	},

	//时间兼容处理
	//默认格式  'yyyy/MM/dd hh:mm:ss'
	dateFormate(date, formate = 'yyyy-MM-dd hh:mm') {
		if (date && Array.isArray(date) && date.length >= 6) {
			if (date.length >= 3 && date.length < 6) {
				let a1 = date.slice(0, 3)
				return a1.join('-')
			} else if (date.length >= 6) {
				let a1 = date.slice(0, 3)
				let a2 = date.slice(3, 6)
				return a1.join('-') + " " + a2.join(':')
			} else {
				return date.join('-')
			}
		}
		if (date && typeof date === 'string' && date.indexOf('T') != -1) {
			if (formate) {
				return this.formate(date, formate)
			}
			return date.replace('T', ' ')
		}
		if (date && typeof date === 'string' && (date.indexOf('/') != -1 || date.indexOf('-') != -1 || date
				.indexOf(
					':') != -1)) {
			if (formate) {
				return this.formate(date, formate)
			}
			return date
		}
		return this.isNoEmpty(date) ? this.formate(date, formate) : ''
	},
	//
	getDateForUtc(date) {
		return Date.UTC(parseInt(date.substr(0, 2)) + 2000, parseInt(date.substr(2, 2)) - 1,
			parseInt(date.substr(4, 2)), parseInt(date.substr(6, 2)), parseInt(date.substr(8, 2)),
			parseInt(date.substr(10, 2)))
	},
	//
	getDataISOString(iso) {
		var ar = iso.split('.')
		console.log('-getDataISOString-=', ar)
		if (ar && Array.isArray(ar) && ar.length > 1) {
			return ar[0]
		}
		return iso
	},
	//返回
	generateUUID() {
		// 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			var r = Math.random() * 16 | 0,
				v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	},
	//解析get请求url，并返回参数对应值。
	parseQueryParams(url) {
		// 如果未提供url，则使用当前页面的url  
		if (!url) url = window.location.href;
		// 获取查询字符串（?后面的部分）  
		let queryString = url.split('?')[1];
		// 如果没有查询字符串，则返回一个空对象  
		if (!queryString) return {};
		// 使用split和reduce来分割参数并生成对象  
		let queryParams = {};
		queryString.split('&').forEach(function(pair) {
			let parts = pair.split('=');
			// 如果存在=，则添加参数到对象  
			if (parts.length > 1) {
				queryParams[parts.shift()] = decodeURIComponent(parts.join('='));
			}
		});
		return queryParams;
	},

	//获取原生工具测试
	getTools() {
		if (this.checkIsHarmonyOS()) {
			return null
		}
		if (!plusTool) {
			console.log('获取原生工具级', this.checkIsAppleDevice())
			console.log('获取原生工具级', this.checkIsAndroidDevice())
			console.log('获取原生工具级', this.checkIsHarmonyOS())
			if (window.plus && plus.os.name === 'Android') {
				let Tool = plus.android.importClass("com.uniapp.pcitc.esign.MyJavascriptInterface");
				plusTool = new Tool()
			} else if (window.plus && plus.os.name === 'iOS') {
				let Tool = plus.ios.importClass("MyJavascriptInterface");
				plusTool = new Tool()
			} else {
				return null
			}
		} else {
			//console.log('不用获取原生工具级')
		}
		return plusTool
	},

	// js判断是否是苹果设备
	checkIsAppleDevice() {
		var u = navigator.userAgent,
			app = navigator.appVersion;
		var ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
		var iPad = u.indexOf("iPad") > -1;
		var iPhone = u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1;
		if (ios || iPad || iPhone) {
			return true;
		} else {
			return false;
		}
	},

	//js判断是否为Android设备
	checkIsAndroidDevice() {
		var u = navigator.userAgent;
		if (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) {
			return true;
		} else {
			return false;
		}
	},

	//js判断是否为鸿蒙系统 OpenHarmony是鸿蒙webview的标识
	checkIsHarmonyOS() {
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;
		console.log('isHarmonyOS-=', userAgent)
		return userAgent.toLowerCase().includes("harmony");
	},

	generate8Password() {
		// 定义字符集
		const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
		const lowercase = 'abcdefghijklmnopqrstuvwxyz';
		const numbers = '0123456789';
		const symbols = '~!@#$%^&*;?:';

		// 合并所有字符
		const allChars = uppercase + lowercase + numbers + symbols;

		// 确保密码包含至少一个每种字符类型
		const randomUppercase = uppercase[Math.floor(Math.random() * uppercase.length)];
		const randomLowercase = lowercase[Math.floor(Math.random() * lowercase.length)];
		const randomNumber = numbers[Math.floor(Math.random() * numbers.length)];
		const randomSymbol = symbols[Math.floor(Math.random() * symbols.length)];

		// 生成剩余4个随机字符
		let otherChars = '';
		for (let i = 0; i < 4; i++) {
			otherChars += allChars[Math.floor(Math.random() * allChars.length)];
		}

		// 组合并打乱顺序
		let password = randomUppercase + randomLowercase + randomNumber + randomSymbol + otherChars;
		password = password.split('')
			.sort(() => Math.random() - 0.5)
			.join('');

		return password;
	}

};

//安卓原生提供的工具集
let plusTool = null;